// Lightweight Google Analytics (gtag.js) event helper.
//
// All product analytics events should go through `trackEvent` so that:
// - Events only fire in production builds (no noise from local dev).
// - A missing/blocked gtag script never breaks app functionality.
// - Event names stay consistent and easy to audit in one place.
//
// Event name conventions (GA4):
// - Use GA4 recommended names where one exists (e.g. `sign_up`).
// - Otherwise use lowercase snake_case `<object>_<verb>` names
//   (e.g. `organization_created`, `invitation_sent`).

export function trackEvent(
  name: string,
  params?: Record<string, unknown>,
): void {
  if (!import.meta.env.PROD) return;
  if (typeof window === "undefined" || typeof window.gtag !== "function")
    return;
  try {
    window.gtag("event", name, params ?? {});
  } catch {
    // Analytics must never break the app.
  }
}
